export class Pwd {
  OldPwd:string;
  NewPwd:string;
}